// extracted by mini-css-extract-plugin
module.exports = {"control-btn-link":"ControlBtnLink_control-btn-link__AfmJV"};